import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {Location} from '@angular/common';
import { TamasAlunoService } from '../tamas-aluno.service';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import { AlertaSimplesDialog } from '../alerta-simples';

import {Local} from '../tamas-models';

@Component({
  selector: 'app-info-local',
  templateUrl: './info-local.component.html',
  styleUrls: ['./info-local.component.css']
})
export class InfoLocalComponent implements OnInit, OnDestroy {
  hideCL: boolean = false;
  nomeCidade: any = '';
  qBuscado: any = '';
  arrResults: any[] = [];
  isFav: boolean = false;
  nomeLocal: any = '';
  qFavIcon: any = '';
  locLogo: any = '';
  urlFoto: any = '';
  // qDadosLocal: Configuracoes[];
  qDadosLocal: Local = new Local();
  constructor(private route: ActivatedRoute, private _location: Location, public router: Router, public tmaService: TamasAlunoService, public dialog: MatDialog) { }

  ngOnInit() {
    this.hideCL = true;
    this.tmaService.eventoFS(true);
    this.nomeCidade = this.route.snapshot.paramMap.get('cidade');
    this.qBuscado = this.route.snapshot.paramMap.get('tipobuscado');
    this.nomeLocal =  this.route.snapshot.paramMap.get('nomelocal');
    this.arrResults.push({qq: 1});
    if(this.isFav){
      this.qFavIcon = 'star';
    }
    else{
      this.qFavIcon = 'star_border';
    }

    this.infoLocal();
  }
  ngOnDestroy(){
    console.log("destroy");
    this.tmaService.eventoFS(false);
  }

  infoLocal() :void{
    //server
    var dadosIn = 'email=' + this.tmaService.hcEmail + '&senha=' + this.tmaService.hcSenha + '&tipodado=local&valordado=' + this.nomeLocal;
        this.tmaService.infoPouLEsp(dadosIn)
        .subscribe((qRes) =>{
          console.log(qRes);
          this.hideCL = true;
          if(qRes['res'] == 'done'){
            this.qDadosLocal = qRes['dadosLocal'];
            this.urlFoto = this.tmaService.urlRepositorioS3 + "/local-logos/";
            this.isFav = qRes['favorito'];
            this.renderBtIcon();
          }
        })
  }



  novaPesquisa() :void{
    this.router.navigate(['/pesquisando/' +  this.route.snapshot.paramMap.get('tipobuscado')])
  }
  
  goPoL(idPro: any, urlAmigavel: any) :void{
      
      if(this.route.snapshot.paramMap.get('tipobuscado') == 'profissionais'){
        this.router.navigate(['/pro/' + urlAmigavel]);
      }
      else{
        this.router.navigate(['/local/' + urlAmigavel]);
      }
  }
  favLocal(){
    this.hideCL = false;
    //construir toda parte server side etc
    if(!this.isFav){
      var dadosIn = 'email=' + this.tmaService.hcEmail + '&senha=' + this.tmaService.hcSenha + '&tipodado=local&valordado=' + this.nomeLocal;
      this.tmaService.addFavLocal(dadosIn)
      .subscribe((qRes) =>{
        console.log(qRes);
        this.hideCL = true;
        if(qRes['res'] == 'done'){
          this.isFav = !this.isFav;
          // this.qFavIcon = 'star';
          this.renderBtIcon();
        }
      })
    }
    else{
      var dadosIn = 'email=' + this.tmaService.hcEmail + '&senha=' + this.tmaService.hcSenha + '&tipodado=local&valordado=' + this.nomeLocal;
      this.tmaService.removeFavLocal(dadosIn)
      .subscribe((qRes) =>{
        console.log(qRes);
        this.hideCL = true;
        if(qRes['res'] == 'done'){
          this.isFav = !this.isFav;
          this.renderBtIcon();
          // this.qFavIcon = 'star_border';
        }
      })
    }
  }

  renderBtIcon() :void{
    if(this.isFav){
      this.qFavIcon = 'star';
    }
    else{
      this.qFavIcon = 'star_border';
    }
  }
  voltar() :void{
    if(this.tmaService.paginaAnterior == ''){
      this.router.navigate(['/pesquisar']);
    }
    else{
      this.router.navigate([this.tmaService.paginaAnterior]);
      //this._location.back();
    }
    
  }

}
